import {
  useGetLocationListNameIdQuery,
  type DeviceFilter,
} from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { uniq } from "lodash";
import { useMemo, useState } from "react";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import {
  ItemGridFilterDataList,
  type FilterValueEntry,
} from "../ItemGridFilter/ItemGridFilterDataList";

type SupportedFilter = DeviceFilter | null | undefined;

export function ItemGridFilterLocations() {
  const [query, setQuery] = useState<string>("");

  const { filter, updateFilterState } = useItemGridFilterContext();
  const { data, loading, error } = useGetLocationListNameIdQuery({
    variables: {
      page: 0,
      perPage: 1000,
      sortField: "name",
      sortOrder: "ASC",
      filter: (query && { q: query }) || undefined,
    },
  });

  const filterWithLocations: SupportedFilter = filter;
  const items = useMemo<FilterValueEntry[]>(() => {
    const values: FilterValueEntry[] =
      data?.items
        ?.slice()
        ?.filter((item) => !!item?.id)
        ?.map((item) => {
          const id = item.id ?? "";
          const name = item.name ?? "";
          const checked = filterWithLocations?.location?.includes(id) ?? false;
          return {
            id,
            name,
            checked,
          };
        }) ?? [];

    return values;
  }, [data?.items, filterWithLocations?.location]);

  return (
    <ItemGridFilterDataList
      error={error}
      items={items}
      loading={loading}
      property="location"
      text="Location"
      onQueryValueChanged={setQuery}
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.location;
          }
        })
      }
      onRequestFilterUpdate={(id, include) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (include) {
              draft.location = uniq([...(draft.location ?? []), id]);
            } else if (draft.location?.length) {
              draft.location = draft.location.filter(
                (location) => location !== id,
              );
            }

            if (!draft.location?.length) {
              delete draft.location;
            }
          }
        })
      }
      onSelectAllChanged={(checked) => {
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (checked) {
              draft.location = items.map((item) => item.id);
            } else {
              delete draft.location;
            }
          }
        });
      }}
    />
  );
}
